<script>
import VueTypes from 'vue-types'

export default {
    name: 'PromiseHandler',
    props: {
        promise: VueTypes.instanceOf(Promise),
        minResolvingTime: VueTypes.number.def(0),
        doImmediately: VueTypes.bool.def(true),
        initialStatus: VueTypes.oneOf(['resolving', 'resolved', 'rejected']).optional,
    },
    data () {
        return {
            status: this.initialStatus || undefined,
            result: undefined,
            error: undefined,
        }
    },

    watch: {
        promise (val) {
            this.execute(val)
        },
    },
    mounted () {
        if (this.doImmediately) this.execute()
    },
    methods: {
        execute (promise = this.promise) {
            const t = Date.now()
            this.status = promise ? 'resolving' : undefined
            if (promise) {
                this.$emit('resolving')
                this.result = undefined
                this.error = undefined
                const sleepUntilMinResolvingTime = new Promise(resolve => setTimeout(resolve, (this.minResolvingTime || 0) - (Date.now() - t)))
                promise
                    .then(result => sleepUntilMinResolvingTime.then(() => {
                        this.result = result
                        this.status = 'resolved'
                        this.$emit('resolved', result)
                    }))
                    .catch(error => sleepUntilMinResolvingTime.then(() => {
                        this.error = error
                        this.status = 'rejected'
                        this.$emit('rejected', error)
                    }))
            }
        },
    },

    render (h) {
        const {
            execute, status, result, error, $scopedSlots,
        } = this
        const data = {
            status,
            error,
            result,
            execute,
            isResolving: status === 'resolving',
            isResolved: status === 'resolved',
            isRejected: status === 'rejected',
        }

        const type = $scopedSlots.combined ? 'combined' : status
        return getSlotVNode(this, h, type, data)
    },
}

function getSlotVNode (vm, h, slotName, data) {
    // use scopedSlots if available
    if (vm.$scopedSlots[slotName]) {
        const node = vm.$scopedSlots[slotName](data)
        if (vm.$DEV && Array.isArray(node) && !node.length) console.warn(`Provided scoped slot "${slotName}" is empty`)
        return node
    }

    const slot = vm.$slots[slotName]
    if (!slot) {
        if (vm.$DEV) console.warn((slot || []).length, `Provided slot "${slotName}" is empty`)
        return undefined
    }
    return slot
}
</script>
